/**
 * @license
 *
 * Copyright IBM Corp. 2021
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Media type.
 */
export enum MEDIA_TYPE {
  /**
   * The default content group, without media.
   */
  NONE = '',

  /**
   * Content media group with an image
   */
  IMAGE = 'Image',

  /**
   * Conten media group with a video.
   */
  VIDEO = 'Video',
}
